var siteMapHtmlManager = (function(){

    function init(){
        $(document).ready(function(){

            if($(".sitemap-listing-component").length){

                var stickyNavbarHeight = $(".sticky-top.navbar.nav-main").innerHeight();
                $(".sitemap-listing-component .left-section .container").css("top", stickyNavbarHeight-1);

            }
        });
    }

    return {init: init}
})(jQuery)